// Export pages
export { default as WelcomeIntro } from './pages/WelcomeIntro';
export { default as ResumeUpload } from './pages/ResumeUpload';
export { default as ResumeConfirmation } from './pages/ResumeConfirmation';
export { default as ProfileReview } from './pages/ProfileReview';
export { default as CareerGoals } from './pages/CareerGoals';
export { default as OnboardingFlow } from './pages/OnboardingFlow';
export { default as OnboardingChat } from './pages/OnboardingChat';

// Export constants
export const WELCOME_ROUTES = {
    INTRO: '/welcome/intro',
    RESUME_UPLOAD: '/welcome/resume-upload',
    RESUME_CONFIRMATION: '/welcome/resume-confirmation',
    PROFILE_REVIEW: '/welcome/profile-review',
    CAREER_GOALS: '/welcome/career-goals',
    ONBOARDING_CHAT: '/welcome/onboarding-chat',
} as const;
